/**
 * ANGEFANGENER TEXT GEHT NICHT MEHR VERLOREN.
 *
 * Rafael, 07.09.2026 18:47Z: „bei diesem Neuladen geht immer Text, den ich schon
 * in einen Chat eingetippt hab, verloren ... das passiert mir immer wieder: ich
 * tippe was, dann kommt der Rebuild, und der getippte Text ist weg."
 *
 * Gemessen an dem Tag: 18:45:03Z Build, 18:45:47Z Reload-Broadcast an alle
 * Clients — waehrend er tippte. Der Eingabetext lebte nur im React-State
 * (CuiLitePanel: useState('')), waehrend Konto, Sitzung und Nachrichten laengst
 * in localStorage gesichert wurden. Ausgerechnet das Einzige, was NUR er hat und
 * niemand wiederherstellen kann, war das Fluechtige.
 *
 * ZWEI DINGE, DIE ZUSAMMENGEHOEREN:
 *   1. Der Entwurf wird gesichert und nach dem Laden zurueckgelegt (dieses Modul).
 *   2. Ein Neuladen wartet, solange er gerade tippt (App.tsx, fragt hier nach).
 * Nur (1) hiesse: der Satz ist da, aber der Faden ist gerissen. Nur (2) hiesse:
 * ein vergessener Entwurf blockiert das Neuladen ewig.
 *
 * WARUM DAS WARTEN TROTZDEM EIN ENDE HAT: weil (1) existiert, ist der Text auch
 * nach einem Neuladen da. Das Warten schuetzt also nur den MOMENT des Tippens,
 * nicht den Text — deshalb darf es nach einer Weile ohne Tastendruck enden,
 * ohne dass etwas verloren geht. Ein Mechanismus, der ewig blockiert, waere ein
 * neuer Fehler, kein Schutz.
 */

const PRAEFIX = 'cui-entwurf-';

/** Wie lange nach dem letzten Tastendruck ein Neuladen noch wartet. */
export const TIPP_SCHUTZ_MS = 10 * 60_000;

/** Ein Entwurf gehoert zur SITZUNG, nicht zum Kasten — wer die Sitzung wechselt,
 *  soll seinen jeweiligen Satz wiederfinden. Ohne Sitzung (neuer Chat) traegt ihn
 *  die Kachel. */
export function entwurfSchluessel(sessionId?: string | null, panelId?: string | null): string {
  return `${PRAEFIX}${sessionId || panelId || 'default'}`;
}

export function leseEntwurf(schluessel: string): string {
  try { return localStorage.getItem(schluessel) ?? ''; } catch { return ''; }
}

/** Merker im Speicher: welche Kaesten haben gerade Text, und wann zuletzt getippt. */
const offen = new Map<string, number>();

export function schreibeEntwurf(schluessel: string, text: string): void {
  try {
    if (text.trim()) {
      localStorage.setItem(schluessel, text);
      offen.set(schluessel, Date.now());
    } else {
      localStorage.removeItem(schluessel);
      offen.delete(schluessel);
    }
  } catch { /* kein Speicher: dann eben nicht — lieber ohne Sicherung tippen als gar nicht */ }
  window.dispatchEvent(new CustomEvent('cui-entwuerfe'));
}

/**
 * Steht gerade irgendwo ungesendeter Text, an dem SOEBEN getippt wurde?
 *
 * Beim Laden ist `offen` leer — ein alter Entwurf aus localStorage haelt also
 * kein Neuladen auf. Das ist Absicht: was schon ueberlebt hat, braucht keinen
 * Schutz mehr.
 */
export function tippschutzAktiv(jetzt = Date.now()): boolean {
  let aktiv = false;
  for (const [schluessel, zeit] of [...offen]) {
    /*
     * GEGEN ZWEI WAHRHEITEN: der Merker allein wuerde reichen, aber er kann von der
     * Ablage abweichen — jemand loescht den Speicher, ein zweiter Tab schreibt, ein
     * Test raeumt auf. Dann haette ein Entwurf, den es nicht mehr gibt, das
     * Neuladen blockiert, und niemand haette gesehen, warum. Also gilt, was
     * WIRKLICH da steht; der Merker liefert nur den Zeitpunkt.
     */
    if (!leseEntwurf(schluessel).trim()) { offen.delete(schluessel); continue; }
    if (jetzt - zeit < TIPP_SCHUTZ_MS) aktiv = true;
  }
  return aktiv;
}
